<template>
  <div>
    <div>
      <div class="common-title">如有历史信息将自动展示，可根据项目具体要求更改</div>
      <el-row :gutter="20" style="margin-bottom:20px">
        <el-col :span="18">
          <el-row :gutter="20" style="margin-bottom:20px">
            <el-col :span="5" style="font-size:16px">寻访方向</el-col>
            <el-col :span="16">
              <el-input
                v-model="project.寻访方向"
                type="textarea"
                placeholder="请填写客户或顾问提出的，人才搜寻方向"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom:20px">
            <el-col :span="5" style="font-size:16px">目标公司</el-col>
            <el-col :span="19">
              <div style="cursor:pointer" @click="createCompany('目标公司')">
                <el-button
                  circle
                  style="width:20px;height:20px;line-height:20px;padding:0"
                  size="mini"
                  icon="el-icon-plus"
                  type="primary"
                ></el-button>
                <el-button type="text" style="padding-top:0;margin-left:5px;margin-bottom:10px">增加公司</el-button>
              </div>
              <div>
                <el-tag
                  v-for="item in 目标公司"
                  :key="item"
                  size="mini"
                  closable
                  style="margin-right:10px;margin-bottom:10px"
                  @close="removeCompany(item, '目标公司')"
                  >{{ item }}</el-tag
                >
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom:20px">
            <el-col :span="5" style="font-size:16px">勿推荐公司</el-col>
            <el-col :span="19">
              <div style="cursor:pointer" @click="createCompany('勿推荐公司')">
                <el-button
                  circle
                  style="width:20px;height:20px;line-height:20px;padding:0"
                  size="mini"
                  icon="el-icon-plus"
                  type="primary"
                ></el-button>
                <el-button type="text" style="padding-top:0;margin-left:5px;margin-bottom:10px">增加公司</el-button>
              </div>
              <div>
                <el-tag
                  v-for="item in 勿推荐公司"
                  :key="item"
                  size="mini"
                  closable
                  style="margin-right:10px;margin-bottom:10px"
                  @close="removeCompany(item, '勿推荐公司')"
                  >{{ item }}</el-tag
                >
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom:20px">
            <el-col :span="5" style="font-size:16px">典型目标人选</el-col>
            <el-col :span="19">
              <div style="cursor:pointer" @click="dialogVisible = true">
                <el-button
                  circle
                  style="width:20px;height:20px;line-height:20px;padding:0"
                  size="mini"
                  icon="el-icon-plus"
                  type="primary"
                ></el-button>
                <el-button type="text" style="padding-top:0;margin-left:5px;margin-bottom:10px">增加人选</el-button>
              </div>
              <div>
                <el-tag
                  v-for="(value, i) in project.典型目标人选"
                  :key="i"
                  size="mini"
                  closable
                  style="margin-right:10px"
                  @close="removeRadish(value.rid)"
                  >{{ value.name }}</el-tag
                >
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <p class="common-tips">1、目标公司：会在人选匹配的过程中优先匹配；</p>
          <p class="common-tips">2、勿推公司：会在人选自动匹配的中屏蔽；</p>
          <p class="common-tips">3、典型目标人选：将作为智能匹配的优先参考标准，提高精准度;</p>
        </el-col>
      </el-row>
    </div>
    <div class="handle-buttons">
      <el-button size="mini" type="primary" @click="next">下一步</el-button>
    </div>
    <selectCompany ref="selectCompany" @confirm="setCompany"></selectCompany>
    <el-dialog title="目标人选" :close-on-click-modal="false" :visible.sync="dialogVisible" :modal="false">
      <div>
        <div class="flex-row flex-wrap item-center mb5">
          <div v-for="(value, i) in 典型目标人选" :key="i" class="label_tag">{{ value.name }}</div>
        </div>
        <div class="drawer-tips ft-gray">
          人选关键词搜索的几种格式： 1、姓名； 2、姓名+空格+公司； 3、姓名+空格+公司+空格+部门； 4、手机号；
        </div>
        <el-input
          v-model="searchWords"
          placeholder="输入关键字，按回车搜索"
          size="mini"
          clearable
          @keyup.enter.native="searchRadishes"
        >
          <el-button slot="append" type="primary" icon="el-icon-search" size="mini" @click="searchRadishes"
            >搜索</el-button
          >
        </el-input>
        <p v-if="insertRadishVisible" style="text-align:center;">
          没有搜索到相关人选，点击 <a @click="insertRadish">新建</a>打开新建人选窗口
        </p>
        <el-table :max-height="450" :data="searchResult" size="mini" style="width: 100%">
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <a @click="onSelectRadish(scope.row)">选择</a>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div>
                <span class="drawer-link" @click="showRadishDetail(scope.row)">{{ scope.row['姓名'] }}</span>
              </div>
              <div style="color:#aaa">{{ scope.row['手机'] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="公司" label="公司" />
          <el-table-column prop="部门" label="部门" />
          <el-table-column prop="目前职位" label="目前职位" />
        </el-table>
      </div>
      <div class="handle-buttons">
        <el-button size="mini" type="primary" @click="confirmRadish">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import selectCompany from '../../../../company/src/hunting/selectCompany.vue'

export default {
  components: { selectCompany },
  props: {
    project: { type: Object, default: () => ({}) },
    activeCarousel: Object
  },
  data() {
    return {
      目标公司: [],
      勿推荐公司: [],
      典型目标人选: [],
      curCompanyType: '',
      dialogVisible: false,
      searchWords: '',
      searchResult: [],
      insertRadishVisible: false,
      companyId: "",
      companyData: null,
      ifChange: false
    }
  },
  watch: {
    project: {
      async handler (newVal) {
        if (!newVal.客户公司 || this.companyData) return
        const { result } = await app.service("company").getCompany(newVal.客户公司)
        this.companyId = result._id
        this.companyData = result
        this.勿推荐公司 = result.勿推荐公司 || []
        this.目标公司 = result.目标公司 || []
      },
      deep: true,
      immediate: true
    },
    activeCarousel () {
      this.ifChange = false
    }
  },
  methods: {
    next () {
      if (this.ifChange) {
        this.$confirm('目标公司和勿推企业已经更改，是否联动到该客户公司？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          app.service("company").modifyCompany({ query: { _id: this.companyId }, data: { 目标公司: this.目标公司, 勿推荐公司: this.勿推荐公司 } })
          this.$emit('next')
        }).catch(() => {
          this.$emit('next')
        });
      } else {
        this.$emit('next')
      }

    },
    createCompany(curCompanyType) {
      this.$refs.selectCompany.open()
      this.curCompanyType = curCompanyType
    },
    setCompany(company) {
      const companyList = Array.from(new Set(this[this.curCompanyType].concat(company)))
      this[this.curCompanyType] = companyList
      this.project[this.curCompanyType] = companyList
      this.ifChange = true
    },
    removeCompany (item, curCompanyType) {
      console.log(this[curCompanyType])
      this[curCompanyType] = this[curCompanyType]&&this[curCompanyType].filter(val => val !== item)
      this.project[curCompanyType] = this.project[curCompanyType]&&this.project[curCompanyType].filter(val => val !== item)
      this.ifChange = true
    },
    removeRadish(id) {
      this.典型目标人选 = this.典型目标人选.filter(val => val.rid !== id)
      this.project.典型目标人选 = this.project.典型目标人选.filter(val => val.rid !== id)
    },
    insertRadish() {
      app.root.$refs.radishAdd && app.root.$refs.radishAdd.open({ 姓名: this.searchWords })
    },
    confirmRadish() {
      this.project.典型目标人选 = this.典型目标人选
      this.dialogVisible = false
    },
    async searchRadishes() {
      if (!this.searchWords) return
      try {
        const { data, status, msg } = await window.app.service('radish').listEs({
          type: '人选',
          keywords: this.searchWords,
          fields: ['姓名', '公司', '部门', '职能模块', '手机'],
          and: true,
        })
        if (status === 'success') {
          this.searchResult = data.data
          this.insertRadishVisible = data.data.length === 0
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async onSelectRadish(radish) {
      this.典型目标人选.push({
        name: radish['姓名'],
        rid: radish._id,
      })
    },
    showRadishDetail(radish) {
      if (!radish || !radish._id) {
        this.$message('没有关联的人选')
        return
      }
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
  },
}
</script>
<style src="../../../statistics/css/addProject.css"></style>
